import { render, staticRenderFns } from "./ArchiveIcon.vue?vue&type=template&id=4ccc587e&"
import script from "./ArchiveIcon.vue?vue&type=script&lang=js&"
export * from "./ArchiveIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports